import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { SharesUsersAppState } from './types';

type ShareUserIdsPayload = { shareId: string; userIds: string[] };

type DeleteShareUserIdPayload = { shareId: string; userId: string };

const initialState: SharesUsersAppState = {};

export const sharesUsersSlice = createSlice({
  name: 'shares_users',
  initialState,
  reducers: {
    setShareUserIds: (state, action: PayloadAction<ShareUserIdsPayload>) => {
      state[action.payload.shareId] = action.payload.userIds;
    },
    deleteShareUserId: (
      state,
      action: PayloadAction<DeleteShareUserIdPayload>,
    ) => {
      state[action.payload.shareId] = state[action.payload.shareId].filter(
        (id) => id !== action.payload.userId,
      );
    },
  },
});

export const { setShareUserIds, deleteShareUserId } = sharesUsersSlice.actions;

export const sharesUsersReducer = sharesUsersSlice.reducer;
